import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthService } from '../../services/auth.service';
import { LeaderboardService } from '../../services/leaderboard.service';
import { UserLeaderboardStats } from '../../dto/leaderboard.dto';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, ProgressSpinnerModule],
  template: `
    <div class="sidebar-container" *ngIf="isAuthenticated">
      <div class="sidebar-content">
        <div class="nav-section" *ngIf="menuItems.length > 0">
          <button
            *ngFor="let item of menuItems"
            pButton
            type="button"
            class="nav-item"
            [class.active]="isActiveRoute(item.routerLink)"
            [routerLink]="item.routerLink"
            (click)="runCommand(item)"
          >
            <i class="pi" [ngClass]="'pi-' + item.icon"></i>
            <span>{{ item.label }}</span>
          </button>
        </div>

        <div class="nav-section" *ngIf="staticMenuItems.length > 0">
          <button
            *ngFor="let item of staticMenuItems"
            pButton
            type="button"
            class="nav-item"
            [class.active]="isActiveRoute(item.routerLink)"
            [routerLink]="item.routerLink"
            (click)="runCommand(item)"
          >
            <i class="pi" [ngClass]="'pi-' + item.icon"></i>
            <span>{{ item.label }}</span>
          </button>
        </div>

        <div class="nav-section bottom-section">
          <div class="leaderboard-container" *ngIf="leaderboardStats">
            <div class="leaderboard-header">
              <h3>Your Stats</h3>
            </div>
            
            <div class="leaderboard-item">
              <div class="leaderboard-label">
                <i class="pi pi-comments"></i>
                <span>Interactions This {{ currentPeriod === 'week' ? 'Week' : 'Year' }}</span>
              </div>
              <div class="leaderboard-rank">
                <span class="rank-number">#{{ currentPeriod === 'week' ? leaderboardStats.interactionsRank : leaderboardStats.interactionsRankYear }}</span>
                <span class="rank-total">of {{ currentPeriod === 'week' ? leaderboardStats.interactionsTotal : leaderboardStats.interactionsTotalYear }}</span>
              </div>
            </div>

            <div class="leaderboard-item">
              <div class="leaderboard-label">
                <i class="pi pi-user-plus"></i>
                <span>Follows This {{ currentPeriod === 'week' ? 'Week' : 'Year' }}</span>
              </div>
              <div class="leaderboard-rank">
                <span class="rank-number">#{{ currentPeriod === 'week' ? leaderboardStats.followsRank : leaderboardStats.followsRankYear }}</span>
                <span class="rank-total">of {{ currentPeriod === 'week' ? leaderboardStats.followsTotal : leaderboardStats.followsTotalYear }}</span>
              </div>
            </div>

            <div class="leaderboard-item favorite-category">
              <div class="leaderboard-label">
                <i class="pi pi-star"></i>
                <span>Favorite Category</span>
              </div>
              <div class="category-badge">
                {{ leaderboardStats.favoriteCategory }}
              </div>
            </div>
          </div>

          <div class="leaderboard-loading" *ngIf="loadingStats">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }"></p-progressSpinner>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .sidebar-container {
        width: 250px;
        height: calc(100vh - 60px);
        background-color: #2c2c2c;
        position: fixed;
        left: 0;
        top: 60px;
        overflow-y: auto;
        z-index: 100;
      }

      .sidebar-content {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 1rem 0;
      }

      .nav-section {
        padding: 0.5rem 0;
      }

      .nav-item {
        width: 100%;
        text-align: left;
        padding: 0.75rem 1.5rem;
        margin: 0.25rem 0;
        background: transparent;
        border: none;
        color: #ffffff;
        font-size: 0.95rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        transition: background-color 0.2s ease;
        border-radius: 0;
      }

      .nav-item:hover {
        background-color: #3a3a3a;
      }

      .nav-item.active {
        background-color: #3a3a3a;
        font-weight: 500;
      }

      .nav-item i {
        font-size: 1.1rem;
        width: 20px;
        text-align: center;
      }

      .nav-item span {
        flex: 1;
      }

      .bottom-section {
        margin-top: auto;
        padding-top: 1rem;
        border-top: 1px solid #3a3a3a;
      }

      .leaderboard-container {
        padding: 1rem;
        background-color: #1a1a1a;
        border-radius: 8px;
        margin: 0 0.5rem;
      }

      .leaderboard-header {
        margin-bottom: 1rem;
      }

      .leaderboard-header h3 {
        color: #ffffff;
        font-size: 1rem;
        font-weight: 600;
        margin: 0;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #3a3a3a;
      }

      .leaderboard-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem 0;
        border-bottom: 1px solid #2c2c2c;
      }

      .leaderboard-item:last-child {
        border-bottom: none;
      }

      .leaderboard-item.favorite-category {
        margin-top: 0.5rem;
        padding-top: 1rem;
        border-top: 1px solid #3a3a3a;
      }

      .leaderboard-label {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #cccccc;
        font-size: 0.85rem;
        flex: 1;
      }

      .leaderboard-label i {
        font-size: 0.9rem;
        color: #666666;
      }

      .leaderboard-rank {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 0.25rem;
      }

      .rank-number {
        color: #4CAF50;
        font-weight: 600;
        font-size: 1rem;
      }

      .rank-total {
        color: #999999;
        font-size: 0.75rem;
      }

      .category-badge {
        background-color: #0066cc;
        color: #ffffff;
        padding: 0.25rem 0.75rem;
        border-radius: 12px;
        font-size: 0.85rem;
        font-weight: 500;
      }

      .leaderboard-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
      }

      :host ::ng-deep {
        .p-button {
          border: none;
          box-shadow: none;
        }

        .p-button:focus {
          box-shadow: none;
        }
      }
    `,
  ],
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() menuItems: MenuItem[] = [];
  @Input() staticMenuItems: MenuItem[] = [];
  @Input() isAuthenticated = false;

  leaderboardStats: UserLeaderboardStats | null = null;
  loadingStats = false;
  currentPeriod: 'week' | 'year' = 'week';
  private periodInterval: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private leaderboardService: LeaderboardService
  ) {}

  ngOnInit() {
    if (this.isAuthenticated) {
      this.loadLeaderboardStats();
      this.startPeriodToggle();
    }
  }

  ngOnDestroy() {
    if (this.periodInterval) {
      clearInterval(this.periodInterval);
    }
  }

  startPeriodToggle() {
    // Toggle between week and year every 30 seconds
    this.periodInterval = setInterval(() => {
      this.currentPeriod = this.currentPeriod === 'week' ? 'year' : 'week';
    }, 30000); // 30 seconds
  }

  loadLeaderboardStats() {
    this.loadingStats = true;
    this.leaderboardService.getUserStats().subscribe({
      next: (stats) => {
        this.leaderboardStats = stats;
        this.loadingStats = false;
      },
      error: (error) => {
        console.error('Error loading leaderboard stats:', error);
        this.loadingStats = false;
      },
    });
  }

  isActiveRoute(routerLink: any[] | string | undefined): boolean {
    if (!routerLink) return false;
    const currentUrl = this.router.url || '';
    const link = Array.isArray(routerLink) ? '/' + routerLink.join('/') : routerLink;
    return currentUrl === link || currentUrl.startsWith(link + '/');
  }

  runCommand(item: MenuItem) {
    if (item.command) {
      item.command({ originalEvent: event, item });
    }
  }
}

